module.exports = __webpack_public_path__ + "img/quyu1.cae62ebd.png";